import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SharedPatientData, UserSharedAccountData} from '../../symbols/dashboard-clinic-patients.symbols';
import {User} from '../../../auth/symbols';

@Injectable()
export class DashboardClinicPatientsSingleAccountService {
  constructor(private http: HttpClient) {}

  /**
   * Edit patient data saved on backend.
   */
  public editPatient(patientId: User['uid'], patientData: SharedPatientData): Observable<SharedPatientData> {
    const url = `/api/patient/${patientId}/`;
    return this.http.patch<SharedPatientData>(url, patientData);
  }

  /**
   * Load account related data by patient id.
   */
  loadAccountDataById(patientId: User['uid']): Observable<UserSharedAccountData> {
    const url = `/api/research/patients-scans/${patientId}/`;
    return this.http.get<UserSharedAccountData>(url);
  }
}
